import { render, staticRenderFns } from "./WebHostingRegrade.vue?vue&type=template&id=90e1b276&"
import script from "./WebHostingRegrade.vue?vue&type=script&lang=js&"
export * from "./WebHostingRegrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports